<template>
  <div class="p-4 flex h-full rounded-6xl glass-frosted">
    <div class="relative w-50 h-35 rounded-lg overflow-hidden">
      <img v-if="thumbnail" :src="thumbnail" class="w-full h-full object-cover" draggable="false" />
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    thumbnail: string
  }>()
</script>
